// functions.js
// Provides helpers to call Firebase callable Cloud Functions from the client.
import { getFunctions, httpsCallable } from "firebase/functions";
import { app, ensureAnonymousUser } from "../firebase";

const functionsInstance = getFunctions(app, "us-central1");

export async function makeApiCallAsync(name, params = {}) {
  // Ensure we have an anon user/token before calling
  await ensureAnonymousUser();

  const callable = httpsCallable(functionsInstance, name);

  try {
    const res = await callable(params);
    return res.data;
  } catch (err) {
    // If we raced auth (first page load), retry once after ensuring again
    const msg = String(err?.message || "");
    const code = err?.code || "";
    const isUnauthed =
      code === "functions/unauthenticated" ||
      msg.includes("unauthenticated");

    if (isUnauthed) {
      await ensureAnonymousUser();
      const retry = await callable(params);
      return retry.data;
    }

    // Surface other errors
    console.error(`Error calling Cloud Function ${name}:`, err);
    throw err;
  }
}
